import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const ReadEnd = () => {
    return (
        <div className={styles.readEnd}>
            <div className={styles.readEndLeftLine} />
            <div className={styles.readEndText}>阅读完毕</div>
            <div className={styles.readEndRightLine} />
        </div>
    );
};

export default errorBoundary(ReadEnd);
